import { css } from "styled-components";
import convertHexToRgba from "@kiwicom/orbit-design-tokens/lib/convertHexToRgba";
import { BUTTON_STATES } from "../consts";

var getButtonLinkBoxShadow = function getButtonLinkBoxShadow(state) {
  return function (_ref) {
    var disabled = _ref.disabled,
        theme = _ref.theme,
        transparent = _ref.transparent;

    if (disabled) {
      return null;
    }

    if (state === BUTTON_STATES.ACTIVE && !transparent) {
      return css(["box-shadow:inset 0 0 6px 3px ", ";"], convertHexToRgba(theme.orbit.paletteInkNormal, 8));
    }

    if (state === BUTTON_STATES.FOCUS) {
      return css(["", ";"], !transparent && css(["&:active{box-shadow:inset 0 0 6px 3px ", ";}"], convertHexToRgba(theme.orbit.paletteInkNormal, 8)));
    }

    return null;
  };
};

export default getButtonLinkBoxShadow;